class TikTokReviews extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-tiktok-track]');
    this.prevBtn = this.querySelector('[data-tiktok-prev]');
    this.nextBtn = this.querySelector('[data-tiktok-next]');
    this.dots = this.querySelector('[data-tiktok-dots]');
    this.cards = Array.from(this.track.querySelectorAll('.tiktok-reviews__card'));
    this.autoplayDelay = 6000;
    this.autoplayTimer = null;
    this.playing = false;
    this.currentIndex = 0;

    this.buildDots();

    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => this.advance(-1));
    }
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => this.advance(1));
    }

    this.track.addEventListener('click', (event) => {
      const facade = event.target.closest('[data-tiktok-facade]');
      if (!facade) return;
      this.playing = true;
      this.stopAutoplay();
      this.loadVideo(facade);
    });

    this.track.addEventListener('scroll', () => this.updateDots(), { passive: true });

    this.addEventListener('mouseenter', () => this.stopAutoplay());
    this.addEventListener('mouseleave', () => {
      if (!this.playing) this.startAutoplay();
    });

    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && !this.playing) {
          this.startAutoplay();
        } else {
          this.stopAutoplay();
        }
      }, { threshold: 0.25 });
      this.observer.observe(this);
    } else {
      this.startAutoplay();
    }
  }

  disconnectedCallback() {
    this.stopAutoplay();
    if (this.observer) this.observer.disconnect();
  }

  buildDots() {
    if (!this.dots || this.cards.length <= 1) return;
    this.dots.innerHTML = '';
    this.cards.forEach((card, index) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'tiktok-reviews__dot';
      dot.setAttribute('data-tiktok-dot', index);
      dot.setAttribute('aria-label', `Aller à la vidéo ${index + 1}`);
      dot.addEventListener('click', () => this.goTo(index));
      this.dots.appendChild(dot);
    });
    this.updateDots();
  }

  getStep() {
    const card = this.cards[0];
    return card ? card.offsetWidth + 32 : 336;
  }

  updateDots() {
    if (!this.dots || !this.cards.length) return;
    const step = this.getStep();
    const index = Math.round(this.track.scrollLeft / step);
    this.currentIndex = Math.max(0, Math.min(this.cards.length - 1, index));

    this.dots.querySelectorAll('[data-tiktok-dot]').forEach((dot, i) => {
      dot.classList.toggle('is-active', i === this.currentIndex);
    });
  }

  goTo(index) {
    if (!this.track || !this.cards.length) return;
    const step = this.getStep();
    this.track.scrollTo({ left: index * step, behavior: 'smooth' });
    if (!this.playing) this.startAutoplay();
  }

  startAutoplay() {
    this.stopAutoplay();
    this.autoplayTimer = setInterval(() => this.advance(1), this.autoplayDelay);
  }

  stopAutoplay() {
    if (this.autoplayTimer) {
      clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }
  }

  advance(direction) {
    if (!this.track) return;
    const step = this.getStep();
    const max = this.track.scrollWidth - this.track.clientWidth;

    let target = this.track.scrollLeft + direction * step;
    if (target >= max - 5) {
      target = 0;
    } else if (target < 0) {
      target = max;
    }
    this.track.scrollTo({ left: target, behavior: 'smooth' });

    if (!this.playing) this.startAutoplay();
  }

  loadVideo(facade) {
    const videoId = facade.dataset.videoId;
    if (!videoId) return;

    const lang = navigator.language || 'fr-FR';
    let referrer = '';
    try {
      referrer = encodeURIComponent(window.top.location.href);
    } catch (e) {
      referrer = encodeURIComponent(window.location.href);
    }

    const iframe = document.createElement('iframe');
    iframe.src = `https://www.tiktok.com/embed/v2/${videoId}?lang=${lang}&referrer=${referrer}`;
    iframe.setAttribute('sandbox', 'allow-popups allow-popups-to-escape-sandbox allow-scripts allow-top-navigation allow-same-origin');
    iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
    iframe.allowFullscreen = true;
    iframe.referrerPolicy = 'origin';
    iframe.setAttribute('frameborder', '0');
    iframe.title = 'Vidéo TikTok';

    facade.replaceWith(iframe);
  }
}

customElements.define('tiktok-reviews', TikTokReviews);
